export default __webpack_public_path__ + "static/media/errorP.9103eb6c.jpg";